<template>
  <div>
    <form
      id="new_customer"
      novalidate="novalidate"
      class="simple_form new_customer"
      action="/customers"
      accept-charset="UTF-8"
      data-remote="true"
      method="post"
    >
      <input
        name="utf8"
        type="hidden"
        value="✓"
      >
      <input
        type="hidden"
        name="authenticity_token"
        :value="tok"
      >

      <div class="form-group">
        <input
          id="customer_email"
          class="form-control"
          type="hidden"
          :value="email"
          name="customer[email]"
        >
      </div>

      <div class="form-group">
        <label
          class="password optional"
          for="customer_password"
        >
          {{ $t('form.password') }}
        </label>
        <br>
        <input
          id="customer_password"
          ref="customer[password]"
          v-validate="{ required: true, min: 8, regex:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/}"
          autocomplete="off"
          :class="[ originPassword.valid ? 'good-job' : '', 'form-control' ]"
          type="password"
          name="customer[password]"
          data-vv-as="password"
          data-vv-validate-on="input"
        >
        <div>
          <label
            v-show="errors.has('customer[password]')"
            class="error"
          >
            {{ errors.first('customer[password]') }}
          </label>
        </div>
        <div>
          <em class="form-req">{{ $t('passwordComplexity') }}</em>
        </div>
      </div>

      <div class="form-group">
        <label
          class="password optional"
          for="customer_password_confirmation"
        >
          {{ $t('form.password_confirmation') }}
        </label>
        <br>
        <input
          id="customer_password_confirmation"
          v-validate="'required|confirmed:customer[password]'"
          autocomplete="off"
          :class="[ confirmedPassword.valid ? 'good-job' : '', 'form-control' ]"
          type="password"
          name="customer[password_confirmation]"
          data-vv-validate-on="input"
          data-vv-as="password"
          @keyup.enter="submit"
        >
        <label
          v-show="errors.has('customer[password_confirmation]')"
          class="error"
        >{{ errors.first('customer[password_confirmation]') }}</label>
      </div>
      <div class="form-group">
        <input
          id="submitBtn"
          type="submit"
          name="commit"
          :value="$t('signUp')"
          class="btn btn-primary btn-block create-acct-btn"
          data-disable-with="Sign up"
          :disabled="!originPassword.valid || !confirmedPassword.valid"
        >
      </div>
    </form>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate'

export default {
  props: ['email', 'tok'],
  data() {
    return {
      disabled: true,
    }
  },
  computed: mapFields({
    originPassword: 'customer[password]',
    confirmedPassword: 'customer[password_confirmation]'
  }),
  methods: {
    submit() {
      var input = document.getElementById('customer_password_confirmation')
      input.addEventListener('keyup', function(e) {
        if (e.keyCode === 13) {
          document.getElementById('submitBtn').click()
        }
      })
    },
  }
}
</script>
